import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-home2',
  templateUrl: './home2.component.html',
  styleUrls: ['./home2.component.scss']
})
export class Home2Component implements OnInit, OnDestroy {
  ngOnInit(): void {
    document.body.classList.add('home2-page');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('home2-page');
  }
}
